module.exports = __webpack_public_path__ + "static/img/bg4.3c5ee765.png";